import { observable, toJS } from 'mobx';

export default class AssetMediaSegment {
    @observable order = 0;

    @observable groupKey = null;

    @observable groupName = null;

    @observable tcInMs = null;

    @observable tcOutMs = null;

    @observable durationMs = null;

    @observable name = null;

    @observable hasSpecialNaming = false;

    @observable metadata = {};

    constructor(
        order,
        groupKey,
        groupName,
        tcInMs,
        tcOutMs,
        durationMs,
        name,
        hasSpecialName,
        metadata,
    ) {
        this.order = order;
        this.groupKey = groupKey;
        this.groupName = groupName;
        this.tcInMs = tcInMs;
        this.tcOutMs = tcOutMs;
        this.durationMs = durationMs;
        this.name = name;
        this.hasSpecialNaming = hasSpecialName;
        this.metadata = metadata;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        // const labels = object.labels ? object.labels.map(l => AssetLabelModel.fromJS(l)) : [];
        return new AssetMediaSegment(
            object.order,
            object.group_key,
            object.group_name,
            object.tc_in_ms,
            object.tc_out_ms,
            object.duration_ms,
            object.name,
            object.has_special_naming,
            object.metadata
        );
    }
}
